export const getMaxAmount = (from, wallets) => {
  if (from === 'Реальный') {
    return wallets?.code?.credit;
  }
  return wallets?.deposit?.credit;
};
